export default __webpack_public_path__ + "static/media/tsveti.63c2c4be.jpeg";